module.exports = __webpack_public_path__ + "img/huoban7.0e00714d.png";